import { render, staticRenderFns } from "./Screencasts.vue?vue&type=template&id=a4a6352c&scoped=true"
import script from "./Screencasts.vue?vue&type=script&lang=ts"
export * from "./Screencasts.vue?vue&type=script&lang=ts"
import style0 from "./Screencasts.vue?vue&type=style&index=0&id=a4a6352c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a6352c",
  null
  
)

export default component.exports